(function () {
  function getSectionId(button) {
    const section = button.closest('[id^="shopify-section-"]');
    if (!section) return null;
    return section.id.replace('shopify-section-', '');
  }

  function getCurrentPrice(sectionId) {
    const priceEl = document.querySelector(
      `#shopify-section-${sectionId} #Price-${sectionId} .wd-pdp__price-current`
    );
    return priceEl ? priceEl.textContent.trim() : '';
  }

  function restoreSubmitLabel(button) {
    if (!button || !button.matches('.wd-pdp__submit[data-wd-label-desktop]')) return;
    if (button.disabled) return;

    const sectionId = getSectionId(button);
    if (!sectionId) return;

    const desktopEl = button.querySelector('.wd-pdp__submit-label--desktop');
    const mobileEl = button.querySelector('.wd-pdp__submit-label--mobile');
    const price = getCurrentPrice(sectionId);
    const desktop = button.dataset.wdLabelDesktop || '';
    const mobileTemplate = button.dataset.wdLabelMobile || '';

    if (desktopEl) desktopEl.textContent = desktop;
    if (mobileEl) mobileEl.textContent = mobileTemplate.replace('[price]', price);
  }

  function restoreAll(root) {
    (root || document).querySelectorAll('.wd-pdp__submit[data-wd-label-desktop]').forEach(restoreSubmitLabel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => restoreAll());
  } else {
    restoreAll();
  }

  document.addEventListener('productInfo:loaded', () => restoreAll());
  document.addEventListener('shopify:section:load', (event) => restoreAll(event.target));
})();
